// extracted by mini-css-extract-plugin
export default {"title":"index_title_f17Dk","hotList":"index_hotList_ixBRf","emptyComment":"index_emptyComment_KxgXs"};